import React from "react";
import Water from "./Water";

import { useStoreon } from "storeon/react";

const UploadProgress = ({ height = 56 }) => {
  const { uploadPool } = useStoreon("uploadPool");
  let progress = 1;
  if (uploadPool && Object.keys(uploadPool).length > 0) {
    let totalProgress = 1;
    Object.keys(uploadPool).forEach(function(file) {
      totalProgress *= uploadPool[file];
    });
    progress = totalProgress;
  }
  return <Water progress={progress} height={height} />;
};
export default UploadProgress;
